import React, { useState } from "react";
import { FaStar } from "react-icons/fa";
import EAButton from "../../../app/components/shared/Buttons/EAButton";
import ChangePassword from "../../../app/components/MyAccount/ChangePassword";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { logOut } from "../../../app/store/auth/authActions";
import { State } from "../../../app/store";
import useFacility from "../../../utils/hooks/useFacility";
import EAModal from "../../../app/components/shared/Modal/EAModal";
import { Grid } from "@material-ui/core";

declare const config: { B2B_URL: string };

export const B2B_URL = (config && config.B2B_URL) || "http://localhost:8080/eaktywnib2b";

const B2BNavButton: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const userData = useSelector((state: State) => state.auth.userData);
  const facilityIds = useFacility();
  const { configuration } = useSelector((state: State) => state.config);

  const onClick = () => {
    setOpen(!open);
  };

  const handleLogOut = () => {
    dispatch(logOut());
    window.location.href = `${B2B_URL}?objectIds=${facilityIds}`;
  };

  return (
    <>
      <EAButton
        title={"Partner B2B"}
        variant={"outlined"}
        onClick={onClick}
        startIcon={<FaStar title={"Partner B2B"} />}
        fullWidth={!configuration.widgetActive}
      />
      {open && (
        <EAModal
          isOpen={open}
          onClose={() => setOpen(false)}
          title={"Partner B2B"}
          hideButtons
          onAccept={() => {}}

        >
          <Grid container spacing={0} style={{ width: "40vw" }}>
            <Grid item xs={12} style={{ width: "100%", textAlign: "center" }}>
              <span style={{ textAlign: "center", width: "100%", padding: "3px 0"}}>{userData.email}</span>
            </Grid>
            <Grid item xs={6}>
              <ChangePassword b2bPartner />
            </Grid>
            <Grid item xs={6}>
              <EAButton title={t("wyloguj_sie")} onClick={() => handleLogOut()} fullWidth variant="text" />
            </Grid>
          </Grid>
        </EAModal>
      )}
    </>
  );
};

export default B2BNavButton;
